module.exports = __webpack_public_path__ + "static/media/Placeholder.b5f6922b.png";